import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUserIdsForSelectedTeamIds, getAllParentTeamIdsForChildTeamId, getAllChildTeamIdsForParentTeamId } from './TeamUtils';

// Utilities for when a user selects/deselects a team, looks at the
// state of selected users and teams and returns an updated selection
// based a teams heirarchy and membership
import { jsx as _jsx } from "react/jsx-runtime";
export const getUpdatedSelectionOfUsersAndTeamsFromTeamAdd = ({
  teams,
  addedTeamId,
  previouslySelectedTeamIds,
  previouslySelectedUserIds
}) => {
  // Get all the parent IDs for the in addition to the newly added child team
  const fullListOfTeamIdsToAdd = [addedTeamId, ...getAllParentTeamIdsForChildTeamId(addedTeamId, teams)];

  // For the selected team and any parent ID's that where not previously selected, those are added to the list.
  const newListOfSelectedTeamIds = fullListOfTeamIdsToAdd.reduce((teamIds, id) => {
    if (!teamIds.includes(id)) {
      teamIds.push(id);
    }
    return teamIds;
  }, [...previouslySelectedTeamIds]);

  // For all the teams being added, select all the users from all those teams, add them as well.
  const userIdsToAdd = getUserIdsForSelectedTeamIds(fullListOfTeamIdsToAdd, teams);

  // Go through the list of new user IDs, for any that are not already selected, add them to the list.
  const newListOfSelectedUserIds = userIdsToAdd.reduce((selectedUserIds, userId) => {
    if (!selectedUserIds.includes(userId)) {
      selectedUserIds.push(userId);
    }
    return selectedUserIds;
  }, [...previouslySelectedUserIds]);
  return {
    selectedTeamIds: newListOfSelectedTeamIds,
    selectedUserIds: newListOfSelectedUserIds
  };
};
const getAllSelectedChildrenOfParentTeam = ({
  teams,
  parentId,
  selectedTeamIds
}) => {
  return getAllChildTeamIdsForParentTeamId(parentId, teams).filter(teamId => selectedTeamIds.includes(teamId));
};
export const getUpdatedSelectionOfUsersAndTeamsFromTeamRemove = ({
  teams,
  removedTeamId,
  previouslySelectedTeamIds,
  previouslySelectedUserIds
}) => {
  // Create a list of the parent ID and any currently selected child team Ids for removal
  const fullListOfTeamIdsToRemove = [removedTeamId, ...getAllSelectedChildrenOfParentTeam({
    teams,
    parentId: removedTeamId,
    selectedTeamIds: previouslySelectedTeamIds
  })];

  // For any team ID's in this list that where previously selected, those will now be de-selected.
  const newListOfSelectedTeamIds = previouslySelectedTeamIds.filter(id => !fullListOfTeamIdsToRemove.includes(id));

  // For all the teams that are being removed, select all the users from all those teams, remove them as well.
  const userIdsToRemove = getUserIdsForSelectedTeamIds(fullListOfTeamIdsToRemove, teams);

  // From the list of currently selected users, remove any who are members of any of the removed team(s)
  const newListOfSelectedUserIds = previouslySelectedUserIds.filter(id => !userIdsToRemove.includes(id));
  return {
    selectedTeamIds: newListOfSelectedTeamIds,
    selectedUserIds: newListOfSelectedUserIds
  };
};
export const defaultDisallowedTeamFormattedMessage = ({
  teamName
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ui-asset-management-lib.tooltips.disallowedTeamTooltip",
    options: {
      teamName
    }
  });
};